<template>
  <div class="line-gauge-container">
    <div class="lg-col lg-label typography--body-3 typography--color-secondary">
      {{ label }}
    </div>

    <div class="lg-col lg-box">
      <LineGauge :value="ratio" :bg-color="bgColor"></LineGauge>
    </div>
  
    <div class="lg-col lg-position-num typography--body-3 typography--color-secondary">
      {{ value || '-' }}{{ unit }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'basic-line-gauge',

    props: {
      value: {
        type: Number,
        default: 50,
      },
      ratio: {
        type: Number,
        default: 50,
      },
      unit: {
        type: String,
        default: '',
      },
      label: {
        type: String,
      },
      bgColor: {
        type: String,
        default: '#00c896',
      },
    },
  };
</script>

<style lang="scss">
  .line-gauge-container {
    position: relative;
    height: 18px;
    display: flex;
    flex-wrap: wrap;

    .lg-col {
      -webkit-box-flex: 0;
    }

    .lg-label {
      width: 18%;
      flex: 0 0 18%;
      line-height: 18px;
    }

    .lg-box {
      width: 56%;
      flex: 0 0 56%;
      padding-top: 4px;
      padding-bottom: 4px;
    }

    .lg-position-num {
      width: 26%;
      flex: 0 0 26%;
      line-height: 18px;
      text-align: right;
      font-weight: 500;
    }

    .lg-position,
    .line-gauge {
      border-radius: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BasicLineGauge.vue